import apiClient from './meta-client';

export type DebugStatus = 'ok' | 'info' | 'warn' | 'error';

export interface DebugEvent {
    id: string;
    ts: number;
    step: string;
    status: DebugStatus;
    message: string;
    sender_id: string | null;
    lead_id: number | null;
    funnel_id: number | null;
    node_id: number | null;
    data: Record<string, unknown>;
}

export interface DebugState {
    enabled: boolean;
    expires_in: number;
}

export interface PageDebugSnapshot {
    page: {
        id: number;
        page_id: string;
        page_name: string;
        user_id: number;
        is_active: number | boolean;
        token_status: string | null;
        timezone: string | null;
        language: string | null;
    }[];
    tokens: {
        app_id: number;
        app_name: string;
        purpose: 'broadcast' | 'funnel' | 'both' | string;
        app_active: number | boolean;
        is_active: number | boolean;
        token_status: string | null;
        [key: string]: unknown;
    }[];
    app_groups: { user_id: number; app_id: number; is_active: number | boolean }[];
    funnels: {
        funnel_id: number;
        nome: string;
        is_active: boolean;
        link_active: boolean;
        outro_dono: boolean;
        gatilhos: { value: string; type: string }[];
    }[];
    webhook: { last_ts?: number | null; last_event_type?: string | null; count_last_5min?: number; error?: string };
    debug: DebugState;
    server_time: number;
}

export interface DebugEventsResponse {
    events: DebugEvent[];
    last_id: string | null;
    debug: DebugState;
}

export const getPageDebugSnapshot = async (pageId: string): Promise<PageDebugSnapshot> => {
    const response = await apiClient.get<PageDebugSnapshot>(`/meta/page-debug/${pageId}`);
    return response.data;
};

export const enablePageDebug = async (pageId: string, minutes = 30): Promise<DebugState> => {
    const response = await apiClient.post<DebugState>(`/meta/page-debug/${pageId}/enable`, null, { params: { minutes } });
    return response.data;
};

export const disablePageDebug = async (pageId: string): Promise<DebugState> => {
    const response = await apiClient.delete<DebugState>(`/meta/page-debug/${pageId}/enable`);
    return response.data;
};

export const getPageDebugEvents = async (pageId: string, after?: string | null): Promise<DebugEventsResponse> => {
    const response = await apiClient.get<DebugEventsResponse>(`/meta/page-debug/${pageId}/events`, {
        params: after ? { after } : undefined,
    });
    return response.data;
};
